import { classNames } from '@fullstory/util/fmt';
import React, { PropsWithChildren } from 'react';
import { Flex } from '../../legacy/Flex';
import css from './table.module.scss';

interface TableProps {
  className?: string;
  fixed?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

/**
 * @deprecated
 */
export class DeprecatedTable extends React.Component<PropsWithChildren<TableProps>> {
  render() {
    const className = classNames(css.table, this.props.className, {
      [css.fixed]: !!this.props.fixed,
    });
    return (
      <table data-component="DeprecatedTable" className={className}>
        {this.props.children}
      </table>
    );
  }
}

/**
 * @deprecated
 */
export class DeprecatedTableHead extends React.PureComponent<PropsWithChildren<TableProps>> {
  render() {
    return (
      <thead data-component="DeprecatedTableHead" className={this.props.className}>
        {this.props.children}
      </thead>
    );
  }
}

/**
 * @deprecated
 */
export class DeprecatedTableBody extends React.PureComponent<PropsWithChildren<TableProps>> {
  render() {
    return (
      <tbody data-component="DeprecatedTableBody" className={this.props.className}>
        {this.props.children}
      </tbody>
    );
  }
}

/**
 * @deprecated
 */
export class DeprecatedTableRow extends React.PureComponent<PropsWithChildren<TableProps>> {
  render() {
    const { children, ...rest } = this.props;
    return (
      <tr data-component="DeprecatedTableRow" {...rest}>
        {children}
      </tr>
    );
  }
}

/**
 * @deprecated
 */
export class DeprecatedTableHeaderCell extends React.PureComponent<PropsWithChildren<TableProps>> {
  render() {
    const { children, ...rest } = this.props;
    return (
      <th data-component="DeprecatedTableHeaderCell" {...rest}>
        {children}
      </th>
    );
  }
}

export enum DeprecatedSortOrder {
  Ascending = 'asc',
  Descending = 'desc',
}

interface TableSortHeaderCellProps extends TableProps {
  order: DeprecatedSortOrder;
  onChange?: (order: DeprecatedSortOrder) => void;
  sortActive?: boolean;
}

/**
 * @deprecated
 */
export class DeprecatedTableSortHeaderCell extends React.PureComponent<
  PropsWithChildren<TableSortHeaderCellProps>
> {
  onChange = () => {
    if (this.props.onChange) {
      this.props.onChange(
        this.props.order === DeprecatedSortOrder.Ascending
          ? DeprecatedSortOrder.Descending
          : DeprecatedSortOrder.Ascending,
      );
    }
  };
  render() {
    const headerIconClass = classNames(css.sortableHeader, this.props.className, {
      [css.asc]: this.props.order === DeprecatedSortOrder.Ascending,
      [css.disabled]: !this.props.sortActive,
    });
    return (
      <th
        data-component="DeprecatedTableSortHeaderCell"
        className={css.sortable}
        role="button"
        onClick={this.onChange}
      >
        <Flex justifyContent="flex-end">
          {this.props.children}
          <span className={headerIconClass} />
        </Flex>
      </th>
    );
  }
}

interface TableCellProps {
  colspan?: number;
}

/**
 * @deprecated
 */
export class DeprecatedTableCell extends React.PureComponent<
  PropsWithChildren<TableProps & TableCellProps>
> {
  render() {
    return (
      <td
        data-component="DeprecatedTableCell"
        className={this.props.className}
        colSpan={this.props.colspan}
      >
        {this.props.children}
      </td>
    );
  }
}
